import { z } from 'zod'

const MetaSchema = z.object({ request_id: z.string() }).passthrough()
const SuccessSchema = z.object({ data: z.unknown(), meta: MetaSchema })
const ErrorSchema = z.object({
  error: z.object({ owner: z.string(), code: z.string(), message: z.string(), recoverability: z.string(), details: z.record(z.unknown()).default({}) }),
  meta: MetaSchema,
})
export type PlenumMeta = z.infer<typeof MetaSchema>

export class PlenumApiError extends Error {
  constructor(
    public readonly owner: string, public readonly code: string, message: string,
    public readonly recoverability: string, public readonly status: number,
    public readonly details: Record<string, unknown> = {},
  ) { super(message); this.name = 'PlenumApiError' }
}

function parse(status: number, body: unknown): { data: unknown; meta: PlenumMeta } {
  const err = ErrorSchema.safeParse(body)
  if (err.success) { const e = err.data.error; throw new PlenumApiError(e.owner, e.code, e.message, e.recoverability, status, e.details) }
  const ok = SuccessSchema.safeParse(body)
  if (ok.success) return { data: ok.data.data, meta: ok.data.meta }
  throw new PlenumApiError('plenum', 'transport_error', `Unrecognized response from Plenum (status ${status})`, 'retry', status)
}

/** The ONE place a Plenum v1 envelope is unwrapped. data is returned as T (caller validates with its per-route zod schema). */
export function unwrapV1<T>(status: number, body: unknown): T { return parse(status, body).data as T }
export function unwrapV1WithMeta<T>(status: number, body: unknown): { data: T; meta: PlenumMeta } {
  const r = parse(status, body); return { data: r.data as T, meta: r.meta }
}
